import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { errMsg } from "../api";

const ACTIVITY = {
  active: { label: "Active", color: "var(--done)" },
  check_in: { label: "Check in", color: "var(--brass-bright)" },
  inactive: { label: "Inactive", color: "var(--crimson)" },
};

function Flag({ activity }) {
  const a = ACTIVITY[activity] || ACTIVITY.inactive;
  return (
    <span className="llh-flag" style={{ color: a.color }}>
      <span className="llh-flag-dot" style={{ background: a.color }} />
      {a.label}
    </span>
  );
}

export default function AdminOverview() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/admin/overview").then(({ data }) => setRows(data)).catch((e) => setErr(errMsg(e)));
  }, []);

  const counts = (rows || []).reduce((acc, r) => { acc[r.activity] = (acc[r.activity] || 0) + 1; return acc; }, {});

  return (
    <div className="llh-page llh-pb-40">
      <header className="llh-header-bar">
        <Link to="/admin" className="llh-navlink"><span className="llh-nav-caret">‹</span> Admin panel</Link>
        <div className="llh-header-title">COACHING</div>
        <Link to="/" className="llh-navlink">Tools</Link>
      </header>

      <main className="llh-main">
        <div className="llh-eyebrow">Who's training</div>
        <h2 className="llh-h2 llh-mb-16">Overview</h2>

        {rows && rows.length > 0 && (
          <div className="llh-ovw-stats">
            <span className="llh-fw-700 llh-c-done">{counts.active || 0} active</span>
            <span className="llh-fw-700 llh-c-brass-bright">{counts.check_in || 0} need a check-in</span>
            <span className="llh-fw-700 llh-c-crimson">{counts.inactive || 0} inactive</span>
          </div>
        )}

        {err && <div className="llh-error-text llh-mb-12">{err}</div>}
        {rows === null ? <div className="llh-spin" /> :
          rows.length === 0 ? <div className="llh-dim">No students yet.</div> :
          rows.map((r) => {
            const last = r.last_workout ? String(r.last_workout).slice(0, 10) : "never";
            return (
              <div key={r.id} className="llh-card llh-mb-10">
                <div className="llh-row-between">
                  <div>
                    <div className="llh-name">{r.display_name}</div>
                    <div className="llh-meta">
                      {r.session_count} session{Number(r.session_count) === 1 ? "" : "s"} · last {last}
                    </div>
                  </div>
                  <div className="llh-col-end">
                    <Flag activity={r.activity} />
                    {r.share_progress
                      ? <Link to={`/admin/students/${r.id}`} className="llh-link-brass">View training →</Link>
                      : <span className="llh-dim-11">Not sharing</span>}
                  </div>
                </div>
              </div>
            );
          })}
      </main>
    </div>
  );
}
